import Keycloak from 'keycloak-js';

const keycloak = new Keycloak({
  url: 'https://corebank.balsham.cloud/auth',
  realm: 'corebank-customers',
  clientId: 'corebank-customer-portal',
});

export default keycloak;
